var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CustomElement, Component, Prop, Event, html, nothing } from '@sick-davinci/ce-decorators';
import { style } from './Tabs.style';
export
/**
 * A `davinci-tabs` groups several `davinci-tab`s and shows a tab bar for switching between the *tab*s.
 * @example
 * ```html
 *    <davinci-tabs>
 *        <davinci-tab label="Modern1">any content</davinci-tab>
 *        <davinci-tab selected label="Modern2">any other</davinci-tab>
 *    </davinci-tabs>
 * 
 *    <davinci-tabs type="classic">
 *        <davinci-tab label="Classic1">any content</davinci-tab>
 *        <davinci-tab selected label="Classic2">any other</davinci-tab>
 *    </davinci-tabs>
 * ```
 * @slot {davinci-tab[]} *tab*s grouped within davinci-tab
 */
let Tabs = (_dec = Component({
  tag: 'davinci-tabs',
  style: [style]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Event('tab-change'), _dec9 = Reflect.metadata("design:type", Object), _dec10 = Event('close-tab'), _dec11 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class Tabs extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "type", _descriptor, this);

    _initializerDefineProperty(this, "closeable", _descriptor2, this);

    _initializerDefineProperty(this, "tabChange", _descriptor3, this);

    _initializerDefineProperty(this, "closeTab", _descriptor4, this);

    this.list = new Array();
    this._index = 0;

    this.handleTabChange = event => {
      event.stopPropagation(); // At least one tab has changed. We need to validate the current selected index.

      this._updateSelectedIndex(this.selectedIndex);

      this.scheduleRender(true);
    };
  }

  /**
   * Index of the selected tab with 0 being the first tab.
   */
  set selectedIndex(index) {
    this._updateSelectedIndex(index);
  }

  get selectedIndex() {
    return this._index;
  }

  _updateSelectedIndex(index) {
    // DAVIBE-527: check and fix type of index-argument.
    if (typeof index !== 'number' || !Number.isInteger(index)) {
      index = 0;
    } // TODO A change-event must only be emitted after a direct user interaction.
    // Currently, a change-event may also be emitted if a tab changes its state
    // (e.g. becomes disabled) or if the selected index becomes changed via script.
    // This needs to be fixed in a future release.


    const hasChanged = this._select(index);

    if (hasChanged) {
      this.tabChange.emit(this._index);
    }
  }
  /**
   * Emitted if a tab is selected. Emits the tab index. The index starts with 0.
   */


  render() {
    return html`
    <div class="labels">
        ${this.list.map((v, i) => html`<span class="headline" id=${i} ?selected=${this._index === i} ?disabled=${v.disabled} @click=${this._onClick}>
            ${v.renderIcon()}
            <span class="label">${v.label}</span>
            ${this._renderCloseIcon()}
          </span>`)}
    </div>
    <div class="tabs">
      <slot @slotchange="${this._generateList}"></slot>
    </div>`;
  }

  componentConnected() {
    this.addEventListener('tab-update', this.handleTabChange);
  }

  componentDisconnected() {
    this.removeEventListener('tab-update', this.handleTabChange);
  }

  componentFirstRender() {
    // Safari (does not call @slotchange from above) fix -- https://github.com/whatwg/dom/issues/447
    this._generateList();
  }

  _onClick(e) {
    const tab = e.target.classList.contains('headline') ? e.target : e.target.parentElement;
    this.selectedIndex = +tab.id;
  }

  _onClickClose(e) {
    e.stopPropagation();
    const index = +e.target.parentElement.id;
    this.list.splice(index, 1);

    this._removeTabFromDom(index);

    if (this.selectedIndex === index) {
      this.selectedIndex = this.list.length === index ? +index - 1 : +index;
    }

    this.scheduleRender(true);
  }

  _removeTabFromDom(tabIndex) {
    const tabElements = Array.from(this.querySelectorAll('davinci-tab'));
    this.removeChild(tabElements[tabIndex]);
    this.closeTab.emit(tabIndex);
  }

  _findClosestEnabledTabIndex(fromIndex, iter) {
    let testIndex = fromIndex;

    while (testIndex > -1 && testIndex < this.list.length) {
      if (this.list[testIndex].disabled) {
        testIndex = iter(testIndex);
      } else {
        return testIndex;
      }
    }

    return -1;
  }
  /**
   * Selects the tab with the given index and updates this tabs' selected index.
   * Invalid values will be sanitized.
   * @param index the index of the tab to be selected.
   * @return true if the index has changed else false.
   */


  _select(index) {
    if (index >= this.list.length) {
      index = this.list.length - 1;
    }

    if (index < 0) {
      index = 0;
    } // Use closest enabled tab BEFORE the current one if the current one is disabled


    let testIndex = this._findClosestEnabledTabIndex(index, i => --i);

    if (testIndex === -1) {
      // Use closest enabled tab AFTER the current one if the current one is disabled
      testIndex = this._findClosestEnabledTabIndex(index, i => ++i);
    }

    if (testIndex < 0) {
      testIndex = 0;
    }

    const hasChanged = this._index !== testIndex;
    this._index = testIndex; // The list needs to be updated even if the index has not changed because a tab may have
    // changed its position or the list may have become longer.

    this.list.forEach((v, i) => {
      v.selected = i === this._index;
    });
    return hasChanged;
  }

  _generateList() {
    const slotElement = this.shadowRoot.querySelector('slot');
    const slotAssignedNodes = slotElement.assignedNodes();
    const slotAssignedTabs = slotAssignedNodes.filter(node => node.nodeName.toLowerCase() === 'davinci-tab');
    slotAssignedTabs.forEach((tab, i) => {
      tab.index = i;
    });
    this.list = slotAssignedTabs;
    const selectedIndex = this.list.findIndex(tab => tab.selected); // If no tab is selected (i.e. selectedIndex === -1) stick with the previous index.
    // This may happen if the tab of the previous tab is removed.

    this._select(selectedIndex === -1 ? this._index : selectedIndex);

    Promise.resolve().then(() => {
      this.scheduleRender(true);
    });
  }

  _renderCloseIcon() {
    if (this.type === 'classic' && this.closeable) {
      return html`<davinci-icon class="close" icon='navigation/close' @click=${this._onClickClose}></davinci-icon>`;
    } else {
      return html`${nothing}`;
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'modern';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "closeable", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "selectedIndex", [_dec6, _dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedIndex"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "tabChange", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "closeTab", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
